"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBSONStreamEncoder = void 0;
const stream = __importStar(require("../core/cross-stream"));
const constants = __importStar(require("./constants"));
const bson = __importStar(require("bson"));
const createBSONStreamEncoder = (params) => {
    let readableStrategy = params?.readableStrategy;
    if (!readableStrategy) {
        readableStrategy = new stream.ByteLengthStrategy({
            highWaterMark: 1024 * 16
        });
    }
    return new stream.Transform({
        transform(chunk, controller) {
            controller.enqueue(bson.serialize(chunk, params?.serialize_options));
        },
        flush(controller) {
            if (params?.sendTerminatorOnEnd ?? true) {
                controller.enqueue(constants.TERMINATOR);
            }
        }
    }, params?.writableStrategy, readableStrategy);
};
exports.createBSONStreamEncoder = createBSONStreamEncoder;
